'use client';
import { LazyMotion } from 'motion/react';

const loadFeatures = () =>
  import('@/assets/framer/features').then((res) => res.default);

export default function LazyMotionWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  return <LazyMotion features={loadFeatures}>{children}</LazyMotion>;
}
